const Constants = {
    //Keys using for storage
    KEY_AUTHENTICATION: 'authentication',
    KEY_TOKEN: 'token',
    KEY_TOKEN_EXPIRATION: 'token_expiration',
    KEY_USER: 'user',
    KEY_TOKEN_GUEST: 'token_guest',

    KEY_LAST_FORM_URL: 'last_form_url',
    KEY_LAST_PROCESS_EXECUTED: 'last_process_id',
    KEY_LAST_FISCAL_CONTACT: 'las_fiscal_contact_id',

    KEY_GOOGLE_USER: 'google_user',

    KEY_SKIP_VERIFICATION_CODE: 'skip_verification_register',

    FILTER_STATUS_ALL: 0,
    FILTER_STATUS_ACTIVE: 1,
    FILTER_STATUS_FINISHED: 2,
    FILTER_STATUS_CANCELED: 3,
    FILTER_STATUS_DELETED: 4,
    FILTER_STATUS_IN_PROCESS: 5,
}

export default Constants